import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { logger } from '../services/logger';
import { isFetchBaseQueryError } from '../services/isFetchBaseQueryError';
import { EnqueueRequest, QueueableError } from '../types/errors';

const ErrorSlice = createSlice({
  name: 'error',
  initialState: {
    errorQueue: new Array<QueueableError>(),
  },
  reducers: {
    enqueueError(state, action: PayloadAction<EnqueueRequest>) {
      // stack 情報を落とす前にログとして出力
      logger.error(action.payload);
      let error: QueueableError;
      if (isFetchBaseQueryError(action.payload)) {
        error = action.payload;
      } else {
        // Error と SerializedError は message をメンバに持つので共通処理
        error = {
          status: 'UNKNOWN_ERROR',
          error: action.payload.message,
        };
      }
      state.errorQueue = [...state.errorQueue, error];
    },
    dequeueError(state) {
      state.errorQueue = state.errorQueue.slice(1);
    },
    resetError(state) {
      state.errorQueue = [];
    },
  },
});

export default ErrorSlice;
export const { enqueueError, dequeueError, resetError } = ErrorSlice.actions;
